import { Box } from '@mui/material';
import { toSxArray } from 'src/utils/sx';
import { PageContainerRootProps } from './page-container.types';

/** Default content width for the centered variant (matches the design's 760px content column). */
export const PAGE_CONTAINER_MAX_WIDTH = 760;

/**
 * Pages split into two width regimes — a centered, reading-width column (most
 * settings/detail pages) and full-bleed (wide tables). Isolating that single
 * decision here means the choice is one prop, the design's content width lives
 * in one constant, and width stays orthogonal to vertical scroll/sticky
 * (PageScaffold) so the two compose freely (e.g. full-bleed sticky header over
 * a centered body).
 *
 * Shared horizontal shell. Owns only the width policy and the responsive
 * gutter. Prefer the `PageContainer.Centered` / `PageContainer.Fluid` variants
 * at call sites.
 */
export const PageContainerRoot = ({
  maxWidth,
  disableGutters,
  sx,
  children,
  ...rest
}: PageContainerRootProps) => (
  <Box
    sx={[
      {
        width: '100%',
        maxWidth: maxWidth ?? 'none',
        mx: maxWidth ? 'auto' : 0,
        px: disableGutters ? 0 : { xs: 2, md: 4 },
      },
      ...toSxArray(sx),
    ]}
    {...rest}
  >
    {children}
  </Box>
);

PageContainerRoot.displayName = 'PageContainerRoot';
